import React from 'react';

import footerlogo from '../../assets/img/about/gussy-footer.png';
import logo from '../../assets/img/gussy-logo.png';

function FooterComponent() {
  const year = new Date().getFullYear();
  return (
    <div id="footer">
      <div className="row">
        <div className="col-md-1 footer-col-div d-flex align-items-center">
          <img alt="logo" className="footer-logo" src={footerlogo} width="80px" />
        </div>
        <div className="col-md-3 footer-col-div">
          <img alt="logo" className="footer-logo" src={logo} width="80px" />
          <p className="body-1-reg">
            Helping homeowners get the best advice through our e-design platform supported by a
            curated furniture and decor marketplace to create the designer home you deserve.
          </p>
        </div>

        <div className="col-md-2 footer-col-div">
          <p className="body-1-reg f-bold">Explore</p>
          <a className="footer-link body-1-reg" href="/about">
            About Gussy
          </a>
          <a className="footer-link body-1-reg" href="/contact-us">
            Join our Team
          </a>
        </div>

        <div className="col-md-2 footer-col-div">
          <p className="body-1-reg f-bold">Support</p>
          <a className="footer-link body-1-reg" href="/contact-us">
            Contact
          </a>
          <a className="footer-link body-1-reg" href="/faqs">
            FAQ
          </a>
          <a className="footer-link body-1-reg" href="/terms-of-use#returnpolicy">
            Returns Policy
          </a>
        </div>

        <div className="col-md-4 footer-col-div">
          <div>
            <a
              alt="facebook"
              href="https://www.facebook.com/gussydesign.ph/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <svg
                className="footer-icon"
                fill="none"
                height="25"
                viewBox="0 0 52 100"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.0225 100V55.2734H0V37.5H15.0225V23.4961C15.0225 8.28125 24.3455 0 37.9579 0C44.48 0 50.0817 0.488281 51.7073 0.703125V16.6016H42.2668C34.8633 16.6016 33.4335 20.1172 33.4335 25.2539V37.5H50.1404L47.8489 55.2734H33.4335V100"
                  fill="#33332B"
                />
              </svg>
            </a>
            <a
              alt="twitter"
              href="https://twitter.com/gussydesign"
              rel="noopener noreferrer"
              target="_blank"
            >
              <svg
                className="footer-icon"
                fill="none"
                height="25"
                viewBox="0 0 123 100"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M110.164 24.9218C110.242 26.0155 110.242 27.1094 110.242 28.2031C110.242 61.5623 84.9214 100 38.6431 100C24.3856 100 11.1411 95.8592 0 88.672C2.02572 88.9062 3.97326 88.9844 6.07691 88.9844C17.841 88.9844 28.6706 85.0001 37.3186 78.2032C26.2554 77.9688 16.9842 70.7032 13.7898 60.7031C15.3482 60.9373 16.9062 61.0936 18.5425 61.0936C20.8018 61.0936 23.0613 60.781 25.1647 60.2344C13.6342 57.8905 4.98599 47.7343 4.98599 35.4687V35.1563C8.33597 37.0313 12.2318 38.2032 16.3607 38.3593C9.58253 33.8279 5.14187 26.0936 5.14187 17.3436C5.14187 12.6562 6.38819 8.35929 8.56979 4.60926C20.9574 19.9217 39.5779 29.9216 60.4574 31.0155C60.0679 29.1405 59.8341 27.1876 59.8341 25.2344C59.8341 11.328 71.0531 1.76132e-07 84.9988 1.76132e-07C92.2444 1.76132e-07 98.7887 3.04687 103.385 7.96875C109.073 6.87505 114.526 4.76557 119.357 1.87501C117.487 7.73452 113.514 12.6564 108.294 15.7812C113.358 15.2346 118.266 13.828 122.785 11.8751C119.357 16.8749 115.072 21.3278 110.164 24.9218V24.9218Z"
                  fill="#33332B"
                />
              </svg>
            </a>
            <a
              alt="instagram"
              href="https://www.instagram.com/gussy.design"
              rel="noopener noreferrer"
              target="_blank"
            >
              <svg
                className="footer-icon"
                fill="none"
                height="25"
                viewBox="0 0 100 100"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M50.0112 24.3613C35.8226 24.3613 24.3781 35.8083 24.3781 50C24.3781 64.1917 35.8226 75.6387 50.0112 75.6387C64.1997 75.6387 75.6442 64.1917 75.6442 50C75.6442 35.8083 64.1997 24.3613 50.0112 24.3613ZM50.0112 66.6685C40.8422 66.6685 33.3463 59.1934 33.3463 50C33.3463 40.8067 40.8199 33.3315 50.0112 33.3315C59.2025 33.3315 66.676 40.8067 66.676 50C66.676 59.1934 59.1801 66.6685 50.0112 66.6685V66.6685ZM82.6715 23.3125C82.6715 26.6373 79.9944 29.2927 76.6927 29.2927C73.3687 29.2927 70.7139 26.615 70.7139 23.3125C70.7139 20.01 73.391 17.3324 76.6927 17.3324C79.9944 17.3324 82.6715 20.01 82.6715 23.3125ZM99.6486 29.3819C99.2694 21.3712 97.44 14.2754 91.5728 8.4291C85.7278 2.58284 78.6336 0.753096 70.6247 0.351445C62.3703 -0.117148 37.6297 -0.117148 29.3754 0.351445C21.3887 0.730782 14.2945 2.56053 8.42722 8.40678C2.55996 14.253 0.752928 21.3489 0.351366 29.3596C-0.117122 37.6158 -0.117122 62.3619 0.351366 70.6181C0.730619 78.6288 2.55996 85.7246 8.42722 91.5709C14.2945 97.4172 21.3664 99.2469 29.3754 99.6486C37.6297 100.117 62.3703 100.117 70.6247 99.6486C78.6336 99.2692 85.7278 97.4395 91.5728 91.5709C97.4177 85.7246 99.2471 78.6288 99.6486 70.6181C100.117 62.3619 100.117 37.6381 99.6486 29.3819V29.3819ZM88.9849 79.4767C87.2448 83.8503 83.8762 87.2197 79.4813 88.9825C72.9002 91.5932 57.2839 90.9907 50.0112 90.9907C42.7384 90.9907 27.0998 91.5709 20.541 88.9825C16.1684 87.242 12.7998 83.8726 11.0374 79.4767C8.42722 72.8941 9.02956 57.2744 9.02956 50C9.02956 42.7257 8.44953 27.0836 11.0374 20.5233C12.7775 16.1497 16.1461 12.7803 20.541 11.0175C27.1221 8.40678 42.7384 9.00926 50.0112 9.00926C57.2839 9.00926 72.9225 8.4291 79.4813 11.0175C83.8539 12.758 87.2225 16.1274 88.9849 20.5233C91.5951 27.1059 90.9928 42.7257 90.9928 50C90.9928 57.2744 91.5951 72.9164 88.9849 79.4767Z"
                  fill="#33332B"
                />
              </svg>
            </a>
            <a
              alt="pinterest"
              href="https://pinterest.com/gussydesign"
              rel="noopener noreferrer"
              target="_blank"
            >
              <svg
                className="footer-icon"
                fill="none"
                height="25"
                viewBox="0 0 100 100"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50C100 77.621 77.621 100 50 100C44.8387 100 39.879 99.2137 35.2016 97.7621C37.2379 94.4355 40.2823 88.9919 41.4113 84.6573C42.0161 82.3185 44.5161 72.7621 44.5161 72.7621C46.1492 75.8669 50.9073 78.5081 55.9677 78.5081C71.0484 78.5081 81.9153 64.6371 81.9153 47.3992C81.9153 30.8871 68.4274 18.5282 51.0887 18.5282C29.5161 18.5282 18.0444 33.004 18.0444 48.7903C18.0444 56.129 21.9556 65.2621 28.1855 68.1653C29.1331 68.6089 29.6371 68.4073 29.8589 67.5C30.0202 66.8145 30.8669 63.4073 31.25 61.8347C31.371 61.3306 31.3105 60.8871 30.9073 60.4032C28.871 57.8831 27.2177 53.2863 27.2177 48.9919C27.2177 37.9637 35.5645 27.2984 49.7984 27.2984C62.0766 27.2984 70.6855 35.6653 70.6855 47.6411C70.6855 61.1694 63.8508 70.5444 54.9597 70.5444C50.0605 70.5444 46.371 66.4919 47.5605 61.5121C48.9718 55.5645 51.6935 49.1532 51.6935 44.8589C51.6935 41.0282 49.6371 37.8226 45.3629 37.8226C40.3427 37.8226 36.3105 43.004 36.3105 49.9597C36.3105 54.3952 37.8024 57.379 37.8024 57.379C37.8024 57.379 32.8629 78.3064 31.9556 82.2177C30.9476 86.5323 31.3508 92.621 31.7742 96.5726C13.1855 89.2944 0 71.1895 0 50C0 22.379 22.379 0 50 0C77.621 0 100 22.379 100 50Z"
                  fill="#33332B"
                />
              </svg>
            </a>
            <a
              alt="whatsapp"
              href="https://wa.link/nls5m3"
              rel="noopener noreferrer"
              target="_blank"
            >
              <svg
                height="25px"
                viewBox="0 0 128 128"
                width="25px"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M 64 2 C 29.8 2 2 29.8 2 64 C 2 74.5 4.5992188 84.800391 9.6992188 93.900391 L 4.4003906 113.30078 C 3.5003906 116.40078 4.3992188 119.60039 6.6992188 121.90039 C 8.9992188 124.20039 12.200781 125.10078 15.300781 124.30078 L 35.5 119 C 44.3 123.6 54.099609 126 64.099609 126 C 98.299609 126 126.09961 98.2 126.09961 64 C 126.09961 47.4 119.7 31.899219 108 20.199219 C 96.2 8.4992187 80.6 2 64 2 z M 64 8 C 79 8 93.099609 13.800391 103.59961 24.400391 C 114.19961 35.000391 120.1 49.1 120 64 C 120 94.9 94.9 120 64 120 C 54.7 120 45.399219 117.59922 37.199219 113.19922 C 36.799219 112.99922 36.300781 112.80078 35.800781 112.80078 C 35.500781 112.80078 35.3 112.80039 35 112.90039 L 13.699219 118.5 C 12.199219 118.9 11.200781 118.09922 10.800781 117.69922 C 10.400781 117.29922 9.6 116.30078 10 114.80078 L 15.599609 94.199219 C 15.799609 93.399219 15.700781 92.600391 15.300781 91.900391 C 10.500781 83.500391 8 73.8 8 64 C 8 33.1 33.1 8 64 8 z M 64 17 C 38.1 17 17 38 17 64 C 17 72.3 19.200781 80.4 23.300781 87.5 C 24.900781 90.3 25.3 93.599219 24.5 96.699219 L 21.599609 107.19922 L 32.800781 104.30078 C 33.800781 104.00078 34.800781 103.90039 35.800781 103.90039 C 37.800781 103.90039 39.8 104.40039 41.5 105.40039 C 48.4 109.00039 56.1 111 64 111 C 89.9 111 111 89.9 111 64 C 111 51.4 106.09922 39.599219 97.199219 30.699219 C 88.399219 21.899219 76.6 17 64 17 z M 43.099609 36.699219 L 45.900391 36.699219 C 47.000391 36.699219 48.099219 36.799219 49.199219 39.199219 C 50.499219 42.099219 53.399219 49.399609 53.699219 50.099609 C 54.099219 50.799609 54.300781 51.699219 53.800781 52.699219 C 53.300781 53.699219 53.100781 54.299219 52.300781 55.199219 C 51.600781 56.099219 50.699609 57.100781 50.099609 57.800781 C 49.399609 58.500781 48.6 59.300781 49.5 60.800781 C 50.4 62.300781 53.299219 67.1 57.699219 71 C 63.299219 76 68.099609 77.600781 69.599609 78.300781 C 71.099609 79.000781 71.900781 78.900391 72.800781 77.900391 C 73.700781 76.900391 76.5 73.599609 77.5 72.099609 C 78.5 70.599609 79.500781 70.900391 80.800781 71.400391 C 82.200781 71.900391 89.400391 75.499219 90.900391 76.199219 C 92.400391 76.899219 93.399219 77.300391 93.699219 77.900391 C 94.099219 78.700391 94.100391 81.599609 92.900391 85.099609 C 91.700391 88.499609 85.700391 91.899609 82.900391 92.099609 C 80.200391 92.299609 77.699219 93.300391 65.199219 88.400391 C 50.199219 82.500391 40.7 67.099609 40 66.099609 C 39.3 65.099609 34 58.100781 34 50.800781 C 34 43.500781 37.799219 40 39.199219 38.5 C 40.599219 37 42.099609 36.699219 43.099609 36.699219 z"
                  fill="#33332B"
                />
              </svg>
            </a>
          </div>
          <div id="contact-info">
            <br className="show-block" />
            <p className="contact-link body-1-reg d-block mb-2">
              hello@gussy.design
            </p>
            <a className="contact-link body-1-reg" href="/terms-of-use">
              Terms of Use
            </a>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a className="contact-link body-1-reg" href="/privacy-policy">
              Privacy Policy
            </a>
          </div>
          <div>
            <div id="copyright-div">
              <p id="copyright">© {year} Gussy. All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FooterComponent;
